import {
  VERIFY_MANUAL_TRANSACTION,
  QR_INIT_MANUAL,
} from "../constants/transaction";

// =====================VERIFY manual transation  ================
const warningModalInitialState = {
  modalShow: false,
  data: "",
};

export const warningModalReducer = (
  state = warningModalInitialState,
  action
) => {
  switch (action.type) {
    case "WARNING_MODAL_SHOW":
      return {
        ...state,
        modalShow: action.payLoad,
        data: action.data,
      };
    case "WARNING_MODAL_CLOSE":
      return {
        ...state,
        modalShow: action.payLoad,
        data: action.data,
      };
    default:
      return state;
  }
};

// =====================get redirectional url  ================

export const getRedictionalUrl = (state = { link: "" }, action) => {
  switch (action.type) {
    case "GET_REDICTIONAL_URL":
      return {
        ...state,
        link: action.payLoad,
      };
    default:
      return state;
  }
};

// =====================LANGUAGE SELECTOR  ================
const languageSelectorInit = {
  lang: "th",
};

export const languageSelectorReducer = (
  state = languageSelectorInit,
  action
) => {
  switch (action.type) {
    case "DEFAULT_LANGUAGE":
      return {
        lang: action.payload,
      };
    case "ENGLISH_LANGUAGE":
      return {
        lang: "en",
      };
    case "THAI_LANGUAGE":
      return {
        lang: "th",
      };
    case "BAHASA_LANGUAGE":
      return {
        lang: "bi",
      };
    default:
      return state;
  }
};
